export const ONBOARDING_CLICK_LEFT_VIDEO_CARD = 'Left Video Card';
export const ONBOARDING_CLICK_MIDDLE_VIDEO_CARD = 'Middle Video Card';
export const ONBOARDING_CLICK_RIGHT_VIDEO_CARD = 'Right Video Card';
export const ONBOARDING_CLICK_VIDEO_CARD = [
    ONBOARDING_CLICK_LEFT_VIDEO_CARD,
    ONBOARDING_CLICK_MIDDLE_VIDEO_CARD,
    ONBOARDING_CLICK_RIGHT_VIDEO_CARD,
];
export const ONBOARDING_CLICK_DISMISS_CARDS = 'Dismiss Video Cards';
